define.alias("ember-useragent/instance-initializers/user-agent", "preview-grid/instance-initializers/user-agent");